import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import { PRIVATE_VEHICLES_RESOURCE } from '../constants';
import { getErrorCodeConvertor } from '../../app/lib/errorCodeConvertor';
import apiRoutes from '../../../app/api/routes';

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});

export default ComposedComponent =>
  compose(
    withTranslation(),
    connect(mapStateToProps),
    reduxFetch(props => [
      {
        resource: 'addVehicleToPrivateList',
        method: 'post',
        request: (vehicle, callback) => ({
          url: apiRoutes.addVehicleToPrivateList({
            organisationId: props.organisationId,
            vehicleId: vehicle.id,
          }),
          meta: {
            callback,
            toaster: {
              onSuccessMessage: props.t('vehicleAddSuccess'),
              onErrorMessage: getErrorCodeConvertor(props.t, 'vehicleAddErr'),
            },
            addToOtherLists: [
              {
                resource: PRIVATE_VEHICLES_RESOURCE,
                listPath: 'values',
                values: vehicle,
              },
            ],
          },
        }),
      },
    ])
  )(props => <ComposedComponent {...props} />);
